import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.copy.title')) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c(VBtn, {
          class: `v-btn-x mx-1 bg-rounded-button-${_vm.color}`,
          attrs: {
            "rounded": "",
            "text": "",
            "color": _vm.color,
            "disabled": !_vm.formIsValid || !_vm.selectedTargetTwins.length
          },
          on: {
            "click": function ($event) {
              return _vm.createRuleCopies();
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fas fa-save")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.copy.submit')) + "\n    ")], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "dtwin-rule-copy"
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "my-4",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.digitalTwins.head')))])]), _c(VExpansionPanelContent, [_c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.copy.twinSelection')) + "\n            ")]), _c('core-dtwin-tree-selection', {
    ref: "twin-tree",
    attrs: {
      "tenantId": _vm.tenantId,
      "selectedTwins": _vm.selectedTargetTwins,
      "selectionObjectFilter": _vm.verifyTwinCanBeUsedAsCopyTarget,
      "loadStates": ""
    },
    on: {
      "deselectedTwin": _vm.onTargetTwinDeselected,
      "selectedTwin": _vm.onTargetTwinSelected
    }
  })], 1)], 1)], 1), _vm.selectedTargetTwins.length && _vm.statesUsedBySourceRule.length ? _c(VExpansionPanels, {
    staticClass: "my-4",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.metrics')))])]), _c(VExpansionPanelContent, [_c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.copy.stateMapping')) + "\n            ")]), _vm._l(_vm.selectedTargetTwins, function (twin, i) {
    return _c(VRow, {
      key: `copy-rule-twin-${i}`
    }, [_c(VCol, {
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "text-bold"
    }, [_vm._v("\n                  " + _vm._s(twin.title) + "\n                  "), _c('span', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(twin.id) + ")")])])]), _vm._l(_vm.rule.properties.stateMetrics, function (stateMetric, j) {
      return _c(VCol, {
        key: `copy-rule-twin-${i}-state-${j}`,
        staticClass: "py-0",
        attrs: {
          "cols": "12",
          "sm": "6"
        }
      }, [_c(VSelect, {
        attrs: {
          "items": _vm.validStatesForMetric(stateMetric.stateId, _vm.$refs['twin-tree'].statesForTwins[twin.id]),
          "color": _vm.color,
          "outlined": _vm.inpOutlined,
          "filled": _vm.inpFilled,
          "rules": _vm.requiredRule,
          "label": `${_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.copy.stateSelectionLabel')} '${stateMetric.key}'`,
          "item-text": "properties.title",
          "item-value": "id",
          "hide-details": "auto",
          "required": ""
        },
        scopedSlots: _vm._u([{
          key: "selection",
          fn: function (data) {
            return [_vm._v(_vm._s(data.item.properties.title) + " (" + _vm._s(data.item.key) + ")")];
          }
        }, {
          key: "item",
          fn: function (data) {
            return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.properties.title) + " (" + _vm._s(data.item.key) + ")")])], 1)];
          }
        }], null, true),
        model: {
          value: _vm.targetTwinsStateMetrics[twin.id][stateMetric.key],
          callback: function ($$v) {
            _vm.$set(_vm.targetTwinsStateMetrics[twin.id], stateMetric.key, $$v);
          },
          expression: "targetTwinsStateMetrics[twin.id][stateMetric.key]"
        }
      })], 1);
    }), _vm._l(_vm.aggregateStatesOfSourceRule, function (aggregate, j) {
      return _c(VCol, {
        key: `copy-rule-twin-${i}-aggregate-${j}`,
        staticClass: "py-0",
        attrs: {
          "cols": "12",
          "sm": "6"
        }
      }, [_c(VSelect, {
        attrs: {
          "items": _vm.validStatesForAggregation(aggregate, _vm.$refs['twin-tree'].statesForTwins[twin.id]),
          "color": _vm.color,
          "outlined": _vm.inpOutlined,
          "filled": _vm.inpFilled,
          "rules": _vm.requiredRule,
          "label": `${_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.copy.stateSelectionAggregationLabel')} '${aggregate.key}'`,
          "item-text": "properties.title",
          "item-value": "id",
          "hide-details": "auto",
          "required": ""
        },
        scopedSlots: _vm._u([{
          key: "selection",
          fn: function (data) {
            return [_vm._v(_vm._s(data.item.properties.title) + " (" + _vm._s(data.item.key) + ")")];
          }
        }, {
          key: "item",
          fn: function (data) {
            return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.properties.title) + " (" + _vm._s(data.item.key) + ")")])], 1)];
          }
        }], null, true),
        model: {
          value: _vm.targetTwinsAggregateStates[twin.id][aggregate.id],
          callback: function ($$v) {
            _vm.$set(_vm.targetTwinsAggregateStates[twin.id], aggregate.id, $$v);
          },
          expression: "targetTwinsAggregateStates[twin.id][aggregate.id]"
        }
      })], 1);
    })], 2);
  })], 2)], 1)], 1) : _vm._e()], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };